module.exports = __webpack_public_path__ + "static/media/meals-white.5aa84411.svg";